module.exports = "<p>vaccine works!</p>\n"